var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-check-group',{ref:"checkGroup",staticClass:"md-check-box",class:( _obj = {}, _obj[("is-" + _vm.cols + "col")] = _vm.cols >= 1, _obj ),attrs:{"options":_vm.options,"value":_vm.value,"disabled":_vm.disabled,"max":_vm.max},on:{"input":_vm.$_onInput},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var option = ref.option;
return _c('div',{key:option.value,staticClass:"md-check-box-col"},[_c('div',{staticClass:"md-check-box-item",class:{
        'is-selected': option.isSelected,
        'is-disabled': option.disabled || _vm.disabled
      },on:{"click":function($event){return _vm.select(option.value)}}},[_vm._t("content",function(){return [_vm._v("\n        "+_vm._s(option.label)+"\n      ")]},{"option":option,"select":_vm.select})],2)])}}],null,true)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71ef208e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/vxmobile/components/check-box/index.vue
// module id = null
// module chunks = 